import React, { useState, useEffect, useRef } from 'react';

import PropTypes from 'prop-types';

import { useCarsState } from '../providers/CarsProvider';

import { hexToRgb } from '../helpers/utils';

import { SketchPicker } from 'react-color';

import TimesIcon from './icons/TimesIcon';

import EditIcon from './icons/EditIcon';

import { validateDepenencies } from '../helpers/cars';

import SingerCustomColorPicker from './SingerCustomColorPicker';

import ImageIcon from './icons/ImageIcon';

import CropIcon from './icons/CropIcon';

const Option = ( { id, label, slug, value, description_html, thumbnail, group_label } ) => {

    const [ carsState, carsDispatch ] = useCarsState();

    const [ thumbBgColor, setThumbBgColor ] = useState( value.colors ? value.colors[0].hex : '#999999' );

    const [ thumbBgImage, setThumbBgImage ] = useState();

    const [ uploadResult, setUploadResult ] = useState();

    const [ pickingColor, setPickingColor ] = useState( false );

    const [ pickPosition, setPickPosition ] = useState( [0,0] );

    const [ customMaterialColor, setCustomMaterialColor ] = useState( false );

    const [ customMaterialColorSinger, setCustomMaterialColorSinger ] = useState( false );

    const [ customTextureUpload, setCustomTextureUpload ] = useState( false );

    const ref_el = useRef();

    const current_group_value = carsState.currentConfiguration[ carsState.selectedGroup.slug ];

    const selected = 
        current_group_value ? 
            Array.isArray( current_group_value ) ? 
                current_group_value.find( o => o.id == id ) 
            : 
                current_group_value.id && current_group_value.id == id
        :
        false

    const [ visible, setVisible ] = useState( false );

    const dispatchCustomValue = color => {

        let str = JSON.stringify( value ).replace( /\[custom\]/gi, color );

        let new_value = JSON.parse( str );

        new_value.thumbnail_color = color;

        carsDispatch( { type: 'setSelectedOption', data:{ id, slug, value: new_value, label, thumbnail, group_label } } );
    }

    const handleOnClick = ( color, image ) => {

        if( customMaterialColor || customMaterialColorSinger ) {

            dispatchCustomValue( color );
        } else {

            if( customTextureUpload && image ) {

                let new_value = { ...value, imageData: image }

                carsDispatch( { type: 'setSelectedOption', data:{ id, slug, value: new_value, label, group_label } } );

            } else {

                carsDispatch( { type: 'setSelectedOption', data: { id, slug, value, label, thumbnail, group_label } } );
            }
        }
    }

    useEffect( () => {

        if( ( customMaterialColor || customMaterialColorSinger ) && selected ) dispatchCustomValue( thumbBgColor );

    }, [ thumbBgColor ] )

    useEffect( () => {

        setVisible( validateDepenencies( carsState.currentConfiguration, value.dependencies ) );

    }, [ carsState.currentConfiguration ] )

    useEffect( () => {

        if( value.type && value.type == "custom_texture_upload" ){

            setCustomTextureUpload( true );
        }

        if( value.type && value.type == "custom_material_color" ){

            setCustomMaterialColor( true );
        }

        if( value.type && value.type == "custom_material_color_singer" ){

            setCustomMaterialColorSinger( true );
        }

        if( value.thumbnail_color ){

            if( value.thumbnail_color.ref ) {

                if( value.thumbnail_color.ref.group && value.thumbnail_color.ref.key ){

                    let ref_group = carsState.currentConfiguration[ value.thumbnail_color.ref.group ]

                    if( ref_group && ref_group.value ){

                        let color_value =  ref_group.value[ value.thumbnail_color.ref.key ]

                        if( color_value ){

                            let rgb = Array.isArray( color_value ) ? color_value : color_value.indexOf("#") !== -1 ? hexToRgb( color_value ) : null;

                            if( rgb.length == 3 ){

                                setThumbBgColor( `rgb(${rgb[0]},${rgb[1]},${rgb[2]})` );
                            }
                        }
                    }
                }
            } else {

                let rgb = Array.isArray( value.thumbnail_color ) ? value.thumbnail_color : value.thumbnail_color.indexOf("#") !== -1 ? hexToRgb( value.thumbnail_color ) : null;

                if( rgb.length == 3 ){

                    setThumbBgColor( `rgb(${rgb[0]},${rgb[1]},${rgb[2]})` );
                }
            }
        } else {

            if( current_group_value && current_group_value.value && current_group_value.id == id && current_group_value.value.thumbnail_color ){

                setThumbBgColor( current_group_value.value.thumbnail_color )
            }
        }

        if( current_group_value && current_group_value.value && current_group_value.id == id && current_group_value.value.imageData ){

            setThumbBgImage( current_group_value.value.imageData )
        }

        return () => {

            setPickPosition([0,0]);

            setPickingColor( false );
        }
    }, [] )

    useEffect(()=>{

        if( current_group_value && current_group_value.value && current_group_value.id == id && current_group_value.value.imageData ){

            setThumbBgImage( current_group_value.value.imageData )
        }
    }, [ current_group_value ] )

    const togglePickingColor = e => {
        
        e.stopPropagation(); 

        let ref_box = ref_el.current.getBoundingClientRect()

        if( ref_box && ref_box.left && ref_box.top && ref_box.width ){

            setPickPosition( [ ref_box.left + ref_box.width - 10, ref_box.top - ( ref_box.top > 400 ? customMaterialColorSinger ? 475 : 200 : ref_box.top > 100 ? 50 : 0 ) ] ); 
        }
        
        setPickingColor(!pickingColor) 
    }

    return <div ref={ref_el} className={`pointer pos-rel p-1 ${ selected ? 'brdr-admin-secondary' : 'brdr-transparent'}`} style={{ display: visible ? 'block' : 'none', borderRadius:5, border:'3px solid', background:'rgba(240,240,240,.6)'}} onClick={ 
        () => handleOnClick( thumbBgColor, thumbBgImage ) }>
        <div className="w-100 bg-cover" style={{ backgroundColor:thumbBgColor, backgroundPosition:'center center', paddingBottom:'95%', backgroundImage:"url('" + ( thumbBgImage || ( thumbnail ) ) + "')", clipPath:'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)'}} >
        </div>
        <div className={`pt-1 text-black`} >
            <h6 className="semi-bold small" style={{marginBottom:3}}>{ label }</h6>
            <p className="text-gray small" dangerouslySetInnerHTML={ { __html:description_html || '' } }></p>
        </div>
        { selected && ( customMaterialColor || customMaterialColorSinger ) && <div className="pos-fixed rounded-4 shadow" style={{ left: pickPosition[0] + 20, top: pickPosition[ 1 ], background:'#ffffff', display: pickingColor ? 'block' : 'none'}}>
            { customMaterialColor && <SketchPicker 
                width={200}
                color={ thumbBgColor }
                presetColors={[]}
                disableAlpha={true}
                onChangeComplete={ color => {
                    
                    setThumbBgColor( color.hex );

                    handleOnClick( color.hex );
                } } 
            /> || <SingerCustomColorPicker 
                color={ thumbBgColor }
                color_data_key={ value.color_data_key }
                onClose={ () => setPickingColor( false ) }
                onChangeComplete={ color => {
                        
                    setThumbBgColor( color.hex );

                    handleOnClick( color.hex );
                } } 
           x /> }
        </div> }
        { selected && customTextureUpload && <div onClick={ e => e.stopPropagation() } style={{display:'flex', zIndex:2, position:'absolute', top:0, right:0, paddingTop:4, gap:4}}>

            {/* reupload */}
            <div className="d-flex align-items-center justify-content-center rounded-4" style={{pointerEvents:'all', backgroundColor:'black', width:30, height:30, cursor:'pointer', position:'relative', color:'white' }}>
                <ImageIcon />
                <input style={{zIndex:2, position:'absolute', height:'100%', width:'100%', opacity:0}} type={"file"} onChange={ evt => {

                    var files = evt.target.files;

                    if( files.length > 0 ){

                        var reader = new FileReader();

                        console.log( "FILES CHANGED" )
                        
                        reader.onload = function() {

                            let new_value = { ...value, imageData: reader.result }

                            carsDispatch( { type: 'setSelectedOption', data: { id, slug, value: new_value, label, group_label } } );

                            setUploadResult( reader.result );
                        }
                        reader.readAsDataURL( files[0] );
                    }
                }} />
            </div>

            { uploadResult && <div className="d-flex align-items-center justify-content-center rounded-4" style={{backgroundColor:'black', width:30, height:30, cursor:'pointer', position:'relative', color:'white' }} onClick={() => {

                let new_value = { ...value, imageData: uploadResult }

                carsDispatch( { type: 'setCroppingOptionImage', data: { id, slug, value: new_value, label, group_label } } );
            }}>
                <CropIcon />
            </div> }
            
            <div></div>
        </div> }
        { selected && ( customMaterialColor || customMaterialColorSinger ) && <button style={{padding:"6px 6px"}} className="pos-abs tr-0 rounded-4 bg-black text-white" onClick={ togglePickingColor }>
            { pickingColor ? <TimesIcon /> : <EditIcon /> }
        </button> }
    </div>
}

Option.propTypes = {
    id: PropTypes.number.isRequired,
    group_label: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    group_slug: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    description_html: PropTypes.string,
    thumbnail: PropTypes.string
}

export default Option;